import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';

export interface HeaderCSSStyle extends UIComponentCSSStyle {
    getHeaderContainerCSSStyle(): object;
    getTitleCSSStyle(): object;
    getTitleDivCSSStyle(): object;
    getListCSSStyle(): object;
    getAnchorCSSStyle(): object;
}

export class HeaderCSSStyleImpl extends UIComponentCSSStyleImpl implements HeaderCSSStyle {

    getHeaderContainerCSSStyle(): object {
        return {
            display: "flex",
            height: "50px",
            justifyContents: "center",
            flexFlow: "row wrap",
            top: 0,
            // paddingLeft: "20px",

            zIndex: 1000,
            backgroundColor: "white",
            // paddingRight: "20px",
        };
    }

    getTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "center",
            height: "40px",
            fontWeight: 900,
            letterSpacing: 0,
            paddingTop: "5px",
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h11),
            color: this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "40px"
        };
    }

    getTitleDivCSSStyle(): object {
        return {
            display: "flex",
            flex: "1",
        };
    }

    getListCSSStyle(): object {
        return {
            display: "inline",
            // paddingLeft: "15px",
            // paddingRight: "15px",
            cursor: "pointer",
        };
    }

    getAnchorCSSStyle(): object {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "40px",
            cursor: "pointer",
            paddingTop: "5px",
            fontWeight: "bold",
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h10),
            // fontSize: '12px',
            color: this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "40px"
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/header/headercss.tsx